export class AppError extends Error {

	title  : string;
	message: string;

	constructor(title: string, message: string ) {

		super(message);
		this.title = title;

		// Set the prototype explicitly.
		Object.setPrototypeOf(this, AppError.prototype);

	}

}
